//#region src/env.ts
const getEnvPlayerVersion = () => {
	try {
		return "10.0.0-rc.4";
	} catch {}
	return "UNKNOWN";
};
const player_version = getEnvPlayerVersion();
const getPlayerVersion = () => player_version;
//#endregion
export { getPlayerVersion };
